import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DetailPicker
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker';
import { localStorageMap } from 'Consts/localStorage';
import { getLightBorder } from 'Components/utils';
import ResizableBox from 'Components/ComponentLibrary/Atoms/ResizableBox';
import Header from './Header';

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 0,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    ...getLightBorder(theme, { left: true, right: true }),
  },
  detailsHolder: {
    flexGrow: 1,
    flexBasis: 1,
    height: '100%',
    overflowY: 'auto',
  },
});

const LeftSideContent = ({
  className,
  classes,
}) => {
  const theme = useTheme();

  return (
    <ResizableBox
      className={classNames(classes.root, className)}
      side={'right'}
      localStorageName={localStorageMap.scenarioLeftSideWidth}
      minSize={theme.dimensions.md}
    >
      <Header />
      <div className={classNames(classes.detailsHolder)}>
        <DetailPicker />
      </div>
    </ResizableBox>
  );
};

LeftSideContent.defaultProps = {
  className: '',
};

LeftSideContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LeftSideContent);
